import React from 'react';
import styles from './WhyReadPro.module.css';
import { Link } from 'react-router-dom';
import AppStore from "../../Assets/Images/app-strore-full.svg";
import PlayStore from "../../Assets/Images/gplay-full.svg";
import QrcodeScan from "../../Assets/Images/qr-code.png";
import WhyReadProGif from "../../Assets/animations/why-readpro.gif";
import { pushToGA } from '../../Services/users';
import { connect } from "react-redux";

interface WhyReadProProps {
    setShowWhyReadPro: any;
    user: any;
}

const WhyReadPro: React.FC<WhyReadProProps> = ({ setShowWhyReadPro, user }) => {

    const handlerClose = () => {
        setShowWhyReadPro(false)
    }

    return (
        <div className={styles.Overlay}>
            <div className={styles.WhyReadPro}>
                <div className={styles.WhyReadProContainer}>
                    <span className={styles.Close} onClick={handlerClose}></span>
                    <div className={styles.WhyReadProLeft}                     
                        onClick={() => {
                            pushToGA(
                                "event_tracking",
                                "read pro",
                                "read pro",
                                "full app banner click",
                                user
                            )

                            window.open("https://property.magicbricks.com/microsite/lp/download-readpro/?utm_source=web_app_download_banner_full&utm_medium=read_pro", "_blank");
                        }}
                    >
                        <div className={styles.WhyReadProWelcome}>Welcome to <strong>ReadPro's Admin Dashboard</strong></div>
                        <div className={styles.WhyReadProQuest}>Did you know?</div>
                        <div className={styles.WhyReadProPitch}>
                            Your Competitors are converting
                            <span className={styles.WhyReadProPitchH}><strong>20% More Leads</strong> using ReadPro's CRM</span>
                            <div className={styles.WhyReadProPitchText}>Available only on the App</div>
                        </div>
                        <div className={styles.WhyReadAppsec}>
                            <div className={styles.WhyReadAppsecL}>
                                Stay ahead in the race! <br />
                                Get the app to <strong>unlock these powerful tools now.</strong>
                            </div>
                            <div className={styles.WhyReadAppsecR}>
                                <div className={styles.WhyReadAppStores}>
                                    <div className={styles.WhyReadAppGstore}>
                                        <a href="https://property.magicbricks.com/microsite/lp/download-readpro/?utm_source=web_app_download_banner_full&utm_medium=read_pro" target="_blank"><img src={PlayStore} alt="playstore" /></a>
                                    </div>
                                    <div className={styles.WhyReadAppAppleStore}>
                                        <a href="https://property.magicbricks.com/microsite/lp/download-readpro/?utm_source=web_app_download_banner_full&utm_medium=read_pro" target="_blank"><img src={AppStore} alt="AppStore" /></a>
                                    </div>
                                </div>
                                <div className={styles.WhyReadAppStorscan}>
                                    <div className={styles.WhyReadAppScanTxt}>Scan to Download</div>
                                    <div className={styles.WhyReadAppScanCode}>
                                        <img src={QrcodeScan} alt="qr" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.WhyReadProRight}                     
                        onClick={() => {
                            pushToGA(
                                "event_tracking",
                                "read pro",
                                "read pro",
                                "full app banner click",
                                user
                            )

                            window.open("https://property.magicbricks.com/microsite/lp/download-readpro/?utm_source=web_app_download_banner_full&utm_medium=read_pro", "_blank");
                        }}
                    >
                        <div className={styles.WhyReadProRightImgBox}>
                            <div className={styles.WhyReadProRightImg}>
                                <img src={WhyReadProGif} alt="whyReadpro" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(WhyReadPro);
